<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="邮寄类型" prop="mailType">
        <a-radio-group button-style="solid" v-model="form.mailType" @change="handleMailTypeChange">
          <a-radio-button :value="0"> 全部 </a-radio-button>
          <a-radio-button :value="1"> 部分 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item v-if="form.mailType === 1" label="选择MAC地址" prop="macIds" :label-col="4" :wrapper-col="14">
        <a-checkbox-group v-model="form.macIds" style="width: 100%">
          <div v-for="mac in macList" :key="mac.id" style="margin-bottom: 8px">
            <a-checkbox :value="mac.id">
              {{ mac.macAddress || mac.address || '--' }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
        <div v-if="macList.length === 0" style="color: #999; font-size: 12px; margin-top: 8px">暂无MAC地址信息</div>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 确认寄回 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { returnRepair, getObj } from '@/api/fix/devRepair'

export default {
  name: 'ConfirmShipment',
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-确认寄回',
      open: false,
      showLoading: false,
      macList: [],

      form: {
        id: undefined,
        mailType: 0,
        macIds: [],
      },

      rules: {
        mailType: [{ required: true, message: '请选择邮寄类型', trigger: 'change' }],
        macIds: [
          {
            validator: (rule, value, callback) => {
              if (this.form.mailType === 1) {
                if (!value || value.length === 0) {
                  callback(new Error('部分邮寄时请至少选择一个MAC地址'))
                  return
                }
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    handleMailTypeChange(e) {
      if (e.target.value === 0) {
        this.form.macIds = []
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate('macIds')
        })
      } else {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validateField('macIds')
        })
      }
    },

    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    reset() {
      this.form = {
        id: undefined,
        mailType: 0,
        macIds: [],
      }
      this.macList = []
      this.$refs.form && this.$refs.form.clearValidate()
    },

    async init(record) {
      this.reset()
      this.form.id = record.id

      try {
        const res = await getObj(record.id)
        if (res && res.data && res.data.repairMacs) {
          this.macList = res.data.repairMacs.map((mac) => ({
            id: mac.id,
            macAddress: mac.macAddress || '',
            address: mac.macAddress || '',
          }))
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error('获取MAC地址列表失败')
      }

      this.open = true
    },

    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          const submitData = {
            id: this.form.id,
            mailType: this.form.mailType,
            macIds: this.form.mailType === 1 ? this.form.macIds : [],
          }

          returnRepair(submitData)
            .then((response) => {
              this.$message.success('确认寄回操作成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {})
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
